/**
 * 空运询价管理前端接口
 */

import { request } from '@/utils/http'
import { type BatchDeleteRequest, type PageResponse } from '@/api/types/common'
import { type EnterpriseContactVO } from '@/api/enterprise-center'
import {
  type InquiryBaseModel,
  type InquiryPageRequest,
  type InquirySaveRequest
} from './inquiry-base'

export interface InquiryAirCargoVO {
  id?: string | number | null
  inquiryId?: string | number | null
  airPalletType?: number | null
  palletCount?: number | null
  containerEquipment?: string | null
  exclusiveCargoHold?: boolean | null
  handlingRequirement?: string | null
  preferredAircraftType?: number | null
  quantity?: number | null
  weight?: number | null
  length?: number | null
  width?: number | null
  height?: number | null
  packageId?: string | number | null
  temperatureStart?: number | null
  temperatureEnd?: number | null
  ventilationDoor?: boolean | null
  ventilationQuantity?: number | null
  humidity?: number | null
  preCooling?: boolean | null
  remarks?: string | null
}

export interface InquiryAirModel extends InquiryBaseModel {
  paymentMethod?: number | null
  loadingCountryId?: string | number | null
  loadingCityId?: string | number | null
  loadingAirportId?: string | number | null
  destinationCountryId?: string | number | null
  destinationCityId?: string | number | null
  destinationAirportId?: string | number | null
  serviceType?: number | null
  hsCode?: string | null
  onePriceSupported?: boolean | null
  quotationDeadline?: string | null
  specialRequirements?: string | null
  cargoList?: InquiryAirCargoVO[] | null
}

export interface InquiryAirPageRequest extends InquiryPageRequest {}

export interface InquiryAirSaveRequest extends InquirySaveRequest {
  paymentMethod?: number | null
  loadingCountryId?: string | number | null
  loadingCityId?: string | number | null
  loadingAirportId?: string | number | null
  destinationCountryId?: string | number | null
  destinationCityId?: string | number | null
  destinationAirportId?: string | number | null
  serviceType?: number | null
  hsCode?: string | null
  onePriceSupported?: boolean | null
  quotationDeadline?: string | null
  specialRequirements?: string | null
  cargoList?: InquiryAirCargoVO[] | null
  contactList?: EnterpriseContactVO[]
}

export const pageInquiryAir = (params: InquiryAirPageRequest) => {
  return request.post<PageResponse<InquiryAirModel>>('/price/inquiry/air/page', params)
}

/** 询报价空运 V2 分页（InquiryAirControllerV2，含三角色报价聚合） */
export const pageInquiryAirV2 = (params: InquiryAirPageRequest) => {
  return request.post<PageResponse<InquiryAirModel>>('/price/inquiry/air/v2/page', params)
}

export const getInquiryAirById = (id: string) => {
  return request.post<InquiryAirModel>('/price/inquiry/air/get', { id })
}

export const getInquiryAirByInquiryNo = (inquiryNo: string) => {
  return request.post<InquiryAirModel>('/price/inquiry/air/get', { inquiryNo })
}

export const saveInquiryAir = (params: InquiryAirSaveRequest) => {
  return request.post<string>('/price/inquiry/air/save', params)
}

export const updateInquiryAir = (params: InquiryAirSaveRequest) => {
  return request.post<boolean>('/price/inquiry/air/update', params)
}

export const batchDeleteInquiryAir = (params: BatchDeleteRequest) => {
  return request.post<boolean>('/price/inquiry/air/batch-delete', params)
}

export const updateConfirmedAirQuotation = (params: { id: string; confirmedQuotationId: string | null }) => {
  return request.post<boolean>('/price/inquiry/air/update-confirmed-quotation', params)
}

/** 询报价空运 V2：更新/取消已确认报价单 */
export const updateConfirmedAirQuotationV2 = (params: { id: string; confirmedQuotationId: string | null }) => {
  return request.post<boolean>('/price/inquiry/air/v2/update-confirmed-quotation', params)
}
